export default "__VITE_ASSET__DdliCy7x__"